export default __webpack_public_path__ + "static/media/game_changers.9e754715.png";